import { Box, Chip, Grid, Typography } from "@mui/material";
import React from "react";
import { string, func } from "prop-types";

interface InfoItemProps {
  label: string;
  value: string | number;
}

const InfoItem = ({ label, value }: InfoItemProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignContent: "center",
      }}
    >
      <Typography sx={{ fontSize: "14px" }}>{label}:</Typography>
      <Chip
        sx={{
          ml: 0.5,
          fontSize: "14px",
          backgroundColor: "primary.50",
          color: "primary.main",
        }}
        size="small"
        label={value}
      />
    </Box>
  );
};

interface InfoBarProps {
  view?: string;
  customerName?: string | number;
  buildingAddress?: string;
  cvr?: string | number;
  accessPeriod?: string;
  status?: string;
  gettext?: (key: string) => string;
}

const InfoBar = (props: InfoBarProps) => {
  const {
    view,
    customerName,
    buildingAddress,
    cvr,
    accessPeriod,
    status,
    gettext,
  } = props;

  return (
    <Box
      sx={{
        p: 1,
        backgroundColor: "secondary.50",
        border: "1px solid",
        borderColor: "secondary.200",
        borderRadius: "8px",
        alignItems: "center",
        display: "flex",
        flexDirection: "row",
      }}
    >
      <Grid
        container
        spacing={2}
        sx={{
          display: "flex",
          justifyItems: "center",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        {view === "Meters" && (
          <Grid size={{ xs: 12, sm: "auto" }}>
            <InfoItem
              label={gettext("Building address")}
              value={buildingAddress}
            />
          </Grid>
        )}

        <Grid size={{ xs: 12, sm: "auto" }}>
          <InfoItem label={gettext("Company name")} value={customerName} />
        </Grid>

        <Grid size={{ xs: 12, sm: "auto" }}>
          <InfoItem label={gettext("CVR")} value={cvr} />
        </Grid>

        <Grid size={{ xs: 12, sm: "auto" }}>
          <InfoItem label={gettext("Access period")} value={accessPeriod} />
        </Grid>

        <Grid size={{ xs: 12, sm: "auto" }}>
          <InfoItem label={gettext("Status")} value={status} />
        </Grid>
      </Grid>
    </Box>
  );
};

InfoItem.propTypes = {
  label: string.isRequired,
  value: string.isRequired,
};

InfoBar.propTypes = {
  view: string.isRequired,
  customerName: string.isRequired,
  buildingAddress: string.isRequired,
  cvr: string.isRequired,
  accessPeriod: string.isRequired,
  status: string.isRequired,
  gettext: func.isRequired,
};

export default InfoBar;
